// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal___rRP-","ModalCard":"Modal_ModalCard__1ud_4","ModalCard__exit-btn":"Modal_ModalCard__exit-btn__1VmjM"};